var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scliente-page-pad"},[_vm._v(" Em breve... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }